import React from 'react';
import { styled } from 'themes';
import { Img } from 'components';
import { useStaticQuery, graphql } from 'gatsby';
import { device } from 'themes/media-queries';

const Collaborators = () => {
  const data = useStaticQuery(graphql`
    query CollaboratorQuery {
      allStrapiCollaborator {
        edges {
          node {
            id
            logo {
              childImageSharp {
                fluid(maxHeight: 640, quality: 90) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  `);

  const collaborators = data.allStrapiCollaborator.edges;
  return (
    <Section>
      <List>
        {collaborators.map(collaborator => {
          return (
            <Collaborator key={collaborator.node.id}>
              <Image
                imgStyle={{ objectFit: 'contain' }}
                fluid={collaborator.node.logo.childImageSharp.fluid}
              />
            </Collaborator>
          );
        })}
      </List>
    </Section>
  );
};

const Section = styled.section`
  grid-column: full-start / full-end;
  background-color: rgba(37, 38, 52, 1);

  display: grid;
  grid-template-columns:
    [full-start] minmax(6rem, 1fr) [semi-full-start] minmax(6rem, 1fr) [center-start]
    repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
    [center-end] minmax(6rem, 1fr) [semi-full-end] minmax(6rem, 1fr) [full-end];

  @media ${device.laptop} {
    grid-template-columns:
      [full-start] minmax(3rem, 1fr) [semi-full-start] minmax(3rem, 1fr) [center-start]
      repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
      [center-end] minmax(3rem, 1fr) [semi-full-end] minmax(3rem, 1fr) [full-end];
  }

  @media ${device.mobileL} {
    padding-top: 2rem;
    padding-bottom: 2rem;

    grid-template-columns:
      [full-start] minmax(1rem, 1fr) [semi-full-start] minmax(1rem, 1fr) [center-start]
      repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
      [center-end] minmax(1rem, 1fr) [semi-full-end] minmax(1rem, 1fr) [full-end];
  }
`;

const List = styled.div`
  grid-column: center-start / center-end;
  display: flex;
  align-items: center;
  height: 87px;

  @media ${device.mobileL} {
    height: 50px;
  }
`;

const Collaborator = styled.div`
  width: 100%;
`;

const Image = styled(Img)`
  height: 37px;
`;

export default Collaborators;
